export default class StatisticsPerDay {
  valor!: number;

  total!: number;

  total2!: number;

  data!: string;
}
